<template>
  <div class="hotMain">
    <div class="hotTitle">
      <div class="hotTitleBox">
        <button
          class="btn1"
          :class="[menuTab === 'top' ? 'active' : '']"
          @click="changeTab('top')"
        >
          热点
        </button>
        <button
          class="btn1"
          :class="[menuTab === 'article' ? 'active' : '']"
          @click="changeTab('article')"
        >
          热文
        </button>
      </div>
      <Course name="hotspot" />
    </div>
    <div v-if="menuTab === 'article'">
      <ArticleMenu txt-type="resource"></ArticleMenu>
    </div>
    <div v-if="menuTab === 'top'">
      <!--      <HotMenu></HotMenu>-->
      <ArticleMenu txt-type="word"></ArticleMenu>
    </div>
  </div>
</template>

<script>
// import HotMenu from "./HotMenu";
import ArticleMenu from "./ArticleMenu";
import Course from "@/components/share/Course";

export default {
  name: "HotList",
  components: {
    // HotMenu,
    ArticleMenu,
    Course
  },
  data() {
    return {
      menuTree: "热榜",
      menuTab: "top"
    };
  },
  watch: {
    menuTab: {
      handler(val) {
        if (val === "top") {
          this.menuTree = "热榜";
        } else {
          this.menuTree = "热文推荐";
          // this.$router.push({ name: "hotarticle" });
        }
      }
    }
  },
  methods: {
    changeTab(tabs) {
      this.menuTab = tabs;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";

.app-course {
  color: #216bed;
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-right: 0px;
}

.btn1 {
  padding: 5px 11px;
  border-radius: 15px;
  cursor: pointer;
  color: #909399;
  background-color: #dde3f2;
}
.hotMain {
  background-color: #ffffff;
  width: 478px;
  font-size: 12px;
  .hotTitle {
    text-align: center;
    padding: 10px 10px 10px 10px;
    background-color: #f5f8ff;
    margin-bottom: 10px;
    position: relative;
    .hotTitleBox {
      width: 100px;
      margin: 0 auto;
      background-color: #dde3f2;
      border-radius: 15px;
    }
  }
  .active {
    background-color: #1058f6;
    color: #fff;
  }
  /deep/ .el-tabs__header {
    background-color: #ffffff !important;
  }
  /deep/.el-tabs__item {
    background-color: #f5f7fa;
    height: 35px;
    line-height: 35px;
    /*padding: 0 15px;*/
    border-bottom-color: #dcdfe6;
    margin-left: 0 !important;
    margin-top: 1px;
  }
  /deep/.el-tabs--border-card {
    border: 0;
    /*border-top: 1px solid #dcdfe6;*/
    webkit-box-shadow: none;
    box-shadow: none;
  }
  /deep/.el-tabs__content {
    padding: 10px;
  }
  /deep/.is-active {
    border-bottom-color: #fff;
    border-top: 1px solid #dcdfe6;
    margin-top: 1px;
  }
}
</style>
